import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePrintedRfqInput,
    ModelSortDirection,
    PrintedRfq,
    UpdatePrintedRfqInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PrintedRfqService {
    private amplifyClient = generateClient();

    constructor() {}

    async getPrintedRfq(id: string): Promise<PrintedRfq | null> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getPrintedRfq,
                    variables: { id }
                })
            ).data.getPrintedRfq;
            return data ? (data as PrintedRfq) : null;
        } catch (error) {
            console.error('Error finding PrintedRfq:', error);
            return null;
        }
    }

    async listAllRfqsPrintedByCreated(
        estatus: string,
        sortDirection: ModelSortDirection = ModelSortDirection.DESC,
        pageLimit: number = 20
    ): Promise<PrintedRfq[]> {
        const rfqs: PrintedRfq[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.ListRfqsPrintedByCreated,
                        variables: {
                            estatus,
                            limit: pageLimit,
                            nextToken,
                            sortDirection
                        }
                    })
                ).data.ListRfqsPrintedByCreated;

                if (response?.items) {
                    rfqs.push(...(response.items as PrintedRfq[]));
                }
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);

            return rfqs;
        } catch (error) {
            console.error('Error listing PrintedRfq:', error);
            return [];
        }
    }

    async listPrintedRfqs(): Promise<PrintedRfq[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPrintedRfqs
                })
            ).data.listPrintedRfqs.items;
            if (data) return data as PrintedRfq[];
        } catch (error) {
            console.error('Error finding PrintedRfq:', error);
            return null;
        }
    }

    async listRfqsPrintedByCreated(estatus: string): Promise<PrintedRfq[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ListRfqsPrintedByCreated,
                    variables: {
                        estatus
                    }
                })
            ).data.ListRfqsPrintedByCreated.items;
            if (data) return data as PrintedRfq[];
        } catch (error) {
            console.error('Error finding PrintedRfq:', error);
            return null;
        }
    }
    async createPrinted(input: CreatePrintedRfqInput): Promise<PrintedRfq> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPrintedRfq,
                    variables: {
                        input
                    }
                })
            ).data.createPrintedRfq;
            if (data) return data as PrintedRfq;
        } catch (error) {
            console.error('Error creating PrintedRfq:', error);
            return null;
        }
    }
    async updatePrintedRfq(input: UpdatePrintedRfqInput): Promise<PrintedRfq> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePrintedRfq,
                    variables: {
                        input
                    }
                })
            ).data.updatePrintedRfq;
            if (data) return data as PrintedRfq;
        } catch (error) {
            console.error('Error creating PrintedRfq:', error);
            return null;
        }
    }
}
